<template>
  <div class="news-container">
    <div class="section">
      <div class="body-container">
        <!-- 通知公告 -->
        <div class="notice-box">
          <div class="main-title">
            <span class="text">通知公告</span>
            <a
              :href="`${$schoolUrl}/notice.html`"
              class="more-btn"
              style="margin-top: 14px"
            >
              <span class="btn-text">查看全部</span>
              <i class="iconfont icongengduo"></i>
            </a>
          </div>
          <div class="content">
            <a
              class="main-notice"
              target="_blank"
              :href="
                '/noticeDetail.html?type=1&id=' + mainRecommendNews.news_id
              "
              v-if="mainRecommendNews"
            >
              <img :src="mainRecommendNews.file_url" />
              <div class="main-notice-content">
                <div class="main-notice-top" :title="mainRecommendNews.name">
                  <div class="title text-overflow">
                    {{ mainRecommendNews.name }}
                  </div>
                </div>
              </div>
            </a>
            <div class="notice-list">
              <el-link
                :underline="false"
                class="notice-item"
                :href="'/noticeDetail.html?type=1&id=' + item.news_id"
                v-for="(item, index) in newsList"
                :key="index"
              >
                <span class="title text-overflow" :title="item.name">· {{ item.name }}</span>
                <div class="date">
                  {{ $utils.formatDate(item.publish_time, "YYYY-MM-DD") }}
                </div>
              </el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.getNewsList();
  },
  data() {
    return { newsList: [], mainRecommendNews: null };
  },
  methods: {
    goToList() {
      window.location.href = `${this.$schoolUrl}/notice.html`;
    },
    async getNewsList() {
      const res = (await this.$http.getRecommendNewsList()) || [];
      if (res[0].file_url) {
        this.mainRecommendNews = res.shift();
      }
      this.newsList = res;
      console.log(this.newsList);
    },
    // 点击卡片进去详情页
    showNewsDetail(id) {
      window.location.href = `${this.$schoolUrl}/noticeDetail.html?id=${id}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.news-container {
  background: url(~assets/images/home/new_bg.jpg);
  background-size: cover;
  .section {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
  }
}
.btn-text {
  margin-right: 8px;
}
.notice-box .content {
  margin-top: 20px;
  display: flex;
  .main-notice {
    width: 468px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
    img {
      display: block;
      width: 468px;
      height: 249px;
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-filter: brightness(70%);
      /* Chrome, Safari, Opera */
      filter: brightness(70%);
      object-fit: cover;
    }
    .main-notice-content {
      padding: 15px;
      line-height: 22px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: url(~assets/images/home/news_item_bg.png);
    }
    .main-notice-top {
      .title {
        font-size: 16px;
        color: #fff;
        line-height: 22px;
      }
      .date {
        font-size: 12px;
        line-height: 17px;
        color: #fff;
      }
    }
    .main-notice-text {
      margin-top: 25px;
      font-size: 12px;
      line-height: 17px;
      color: #999;
    }
  }
  .notice-list {
    flex: 1;
    // margin-left: 20px;
  }
  .notice-item {
    height: 60px;
    display: block;
    padding-left: 20px;
    & + .notice-item {
      border-top: 1px dashed #bbb;
    }

    .title {
      color: #222;
      font-size: 16px;
      line-height: 20px;
      max-width: 489px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover{
        color: $--color-primary;
      }
    }
    .date {
      font-size: 12px;
      line-height: 17px;
      color: #666;
    }
  }
}
</style>
<style scoped>
/deep/ .el-link--inner {
  display: flex;
  align-items: center;
  padding-top: 20px;
  justify-content: space-between;

}
</style>